import { Box, Button, CircularProgress, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { semanticColors } from '@/theme/tokens';

export default function SettingsLoadingState({
  error,
  onRetry,
}: {
  error: boolean;
  onRetry: () => void;
}) {
  const { t } = useTranslation('settings');
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', flexDirection: 'column', gap: 2, py: 6 }}>
      {error ? (
        <>
          <Typography role="alert" sx={{ color: semanticColors.textSecondary }}>
            {t('errorLoadingSettings')}
          </Typography>
          <Button
            onClick={onRetry}
            variant="outlined"
            sx={{
              textTransform: 'none',
              color: semanticColors.textPrimary,
              borderColor: semanticColors.borderMedium,
            }}
          >
            {t('loadingRetry')}
          </Button>
        </>
      ) : (
        <CircularProgress
          size={28}
          aria-label={t('loadingSettings')}
          sx={{ color: semanticColors.textPrimary }}
        />
      )}
    </Box>
  );
}
